// Custom Vec2 class as specified
export class Vec2i {
    constructor(public x: number, public y: number) {}

    static subtract(a: Vec2i, b: Vec2i): Vec2i {
    	return new Vec2i(a.x - b.x, a.y - b.y);
    }

    static add(a: Vec2i, b: Vec2i): Vec2i {
    	return new Vec2i(a.x + b.x, a.y + b.y);
    }

    static scale(v: Vec2i, scale: number): Vec2i {
    	return new Vec2i(v.x * scale, v.y * scale);
    }

    static dot(a: Vec2i, b: Vec2i): number {
    	return a.x * b.x + a.y * b.y;
    }

    length(): number {
    	return Math.sqrt(this.x * this.x + this.y * this.y);
    }

    normalize(): Vec2i {
    	const len = this.length();
    	return len > 0 ? new Vec2i(this.x / len, this.y / len) : new Vec2i(0, 0);
    }

    perpendicular(): Vec2i {
    	return new Vec2i(-this.y, this.x);
    }
}